module.exports = __webpack_public_path__ + "img/similar.0e56c0bf.svg";